module.exports = __webpack_public_path__ + "assets/img/8.74a83e11.png";